/**
 * Public seller submission image upload API (M14).
 */
import { API_BASE_URL } from "../config/apiBaseUrl";
import { SELLER_SUBMISSION_API_PATH } from "../utils/sellerIntake/sellerIntakeConstants";

/**
 * @param {string} submissionId
 * @param {File} file
 * @param {{ uploadToken?: string|null, fetchFn?: typeof fetch }} [options]
 */
export async function uploadSellerSubmissionImage(submissionId, file, options = {}) {
  const { fetchFn = fetch, uploadToken = null } = options;

  const formData = new FormData();
  formData.append("image", file);

  const headers = {
    Accept: "application/json",
  };

  if (uploadToken) {
    headers["X-Seller-Upload-Token"] = uploadToken;
  }

  const response = await fetchFn(
    `${API_BASE_URL}${SELLER_SUBMISSION_API_PATH}/${encodeURIComponent(submissionId)}/images`,
    {
      method: "POST",
      headers,
      body: formData,
    }
  );

  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }

  if (response.ok && body?.ok !== false) {
    return {
      ok: true,
      message: body.message || "Foto recibida.",
      images: body.images || [],
    };
  }

  return {
    ok: false,
    message: body?.message || "No pudimos subir la foto.",
    images: body?.images || [],
  };
}

/**
 * @param {string} submissionId
 * @param {File[]} files
 * @param {{ uploadToken?: string|null, fetchFn?: typeof fetch, onProgress?: (done: number, total: number) => void }} [options]
 */
export async function uploadSellerSubmissionImages(submissionId, files = [], options = {}) {
  const { onProgress, ...rest } = options;
  const results = [];
  let successCount = 0;
  let failureCount = 0;

  for (let index = 0; index < files.length; index += 1) {
    const file = files[index];
    const result = await uploadSellerSubmissionImage(submissionId, file, rest);
    results.push(result);
    if (result.ok) successCount += 1;
    else failureCount += 1;
    onProgress?.(index + 1, files.length);
  }

  return {
    ok: failureCount === 0,
    partial: successCount > 0 && failureCount > 0,
    successCount,
    failureCount,
    results,
  };
}
